export default __webpack_public_path__ + "static/Perroquet-site-web-membre-marseille-innovation-8db14c828c705c99a14a20bbe777d4aa.jpg";